function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("title", null, "6C0D13D9-555E-4DA1-9857-91CD707A549A");
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Lodge-enquiry",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "lodge-enq-lodged-open-MD",
  transform: "translate(-660.000000, -502.000000)",
  stroke: "#FFDE00"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-16",
  transform: "translate(640.000000, 488.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ui/icon/utility/24/gas-circle",
  transform: "translate(20.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "circle",
  cx: 12,
  cy: 12,
  r: 11.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3541333,4.5016852 C11.6843291,5.38831534 11.423327,6.46866993 11.5309503,7.51054759 C11.6389455,8.5560267 12.1180825,9.56257989 12.9457429,10.3159212 C14.1174294,9.81999906 14.4945587,9.24612552 14.7450451,8.61585803 C15.5815719,8.99442183 16.2149483,9.52258857 16.6607949,10.1497274 C17.2419433,10.9671849 17.5030287,11.9476481 17.5,12.9631342 C17.5,14.4924455 16.884131,15.8771132 15.8879945,16.8793654 C14.8929575,17.8805115 13.5184032,18.5 11.9999713,18.5 C10.4815451,18.5 9.10700845,17.8805155 8.11198631,16.8793749 C7.1170134,15.8782838 6.50142889,14.4956608 6.5000087,12.9683509 C6.54260785,11.0945713 7.1397509,9.32430886 8.15908539,7.84938412 C9.17897455,6.37365681 10.621551,5.19358655 12.3541333,4.5016852 Z",
  id: "Shape"
})))));
const SvgUiIconUtility24GasCircle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUiIconUtility24GasCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ui-icon-utility-24-gas-circle.bffa269a.svg";
export { ForwardRef as ReactComponent };